import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useState } from "react";
import Header from "../home/header";
import UTILS from "../../utils/commons"
import InventoryItem from "./inventory_item";
import Loading from "../home/Loading";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";

const Inventory = () => {
    let navigate = useNavigate();
    var location = useLocation();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );

    const storedData = JSON.parse( JSON.stringify( location.state ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ data, setData ] = useState( [] );
    const [ filteredData, setFilteredData ] = useState( data )
    const [ loading, setLoading ] = useState( false );


    const prepareData = ( data ) => {
        const result = []
        const products = data.map( d => d.product )
        const productIds = products.map( p => p.id );
        const uniqueProductIds = [ ...new Set( productIds ) ];
        const uniqueProducts = uniqueProductIds.map( id => products.find( p => p.id === id ) );

        if ( loginState.role === UTILS.SALES ) {
            uniqueProducts.forEach( up => {
                const dataItems = data.filter( d => d.product.id === up.id );
                let item = { product: up, totalQuantity: 0, totalAmount: 0, totalAvailable: 0, totalSold: 0, items: [] };
                dataItems.forEach( d => {
                    item.totalQuantity += Number( d.quantity );
                    item.totalAvailable += Number( d.quantity - d.sold );
                    item.totalAmount += ( d.quantity * Number( d.sellingPrice ) );
                    item.totalSold += Number( d.sold ) * Number( d.sellingPrice );
                    item.items.push( { invoiceNumber: d.invoiceNumber, stockQuantity: d.quantity, availableQuantity: d.quantity - d.sold, buyingPrice: d.buyingPrice, sellingPrice: d.sellingPrice, createdAt: d.createdAt, id: d.id } );
                }
                );
                result.push( item );
            } )
        }
        else {
            uniqueProducts.forEach( up => {
                const dataItems = data.filter( d => d.product.id === up.id );
                let item = { totalIssued: 0, totalSold: 0, product: up, totalQuantity: 0, totalAmount: 0, totalAvailable: 0, items: [] };
                dataItems.forEach( d => {
                    item.totalQuantity += Number( d.stockQuantity );
                    item.totalAvailable += Number( d.availableQuantity );
                    item.totalAmount += ( d.availableQuantity * Number( d.sellingPrice ) );
                    item.totalIssued += ( Number( d.stockQuantity ) - Number( d.availableQuantity ) ) * Number( d.sellingPrice )
                    if ( d.soldAmountFromTransactions !== undefined && d.soldAmountFromTransactions !== null ) {
                        item.totalSold = Number( d.soldAmountFromTransactions );
                    }
                    item.items.push( { invoiceNumber: d.invoiceNumber, stockQuantity: d.stockQuantity, availableQuantity: d.availableQuantity, buyingPrice: d.buyingPrice, sellingPrice: d.sellingPrice, createdAt: d.createdAt, id: d.id } );
                }
                );
                result.push( item );
            } );
        }
        setData( result );
        setFilteredData( result );
    }

    const loadIssues = async () => {
        setLoading( true );
        try {
            const response = await apiClient.get( `issues/profile/${loginState.profile.id}` );
            if ( response.status === 401 ) {
                navigate( '/signin', { replace: true } );
                return;
            }

            if ( response.status === 200 ) {
                const invData = await response.data;
                setData( invData );
                setFilteredData( invData );
                prepareData( invData )
                setLoading( false );

            }
            else {
                alert( "Failed to load inventory data" );
            }
        } catch ( e ) {
            setLoading( false );
            if ( e instanceof AxiosError && e.status === 401 ) {
                navigate( '/signin', { replace: true, target: '/inventory' } );
                return;
            }
        }
        setLoading( false );
    }

    const loadInventory = async () => {
        setLoading( true );
        try {
            const response = await apiClient.get( 'inventory' );
            if ( response.status === 401 ) {
                navigate( '/signin', { replace: true } );
                return;
            }

            if ( response.status === 200 ) {
                const invData = await response.data;
                setData( invData );
                setFilteredData( invData );
                prepareData( invData )
                setLoading( false );

            }
            else {
                alert( "Failed to load inventory data" );
            }
        } catch ( e ) {
            setLoading( false );
            if ( e instanceof AxiosError && e.status === 401 ) {
                navigate( '/signin', { replace: true, target: '/inventory' } );
                return;
            }
        }
        setLoading( false );
    }
    useEffect( () => {
        if ( loginState.role === UTILS.SALES ) loadIssues();
        else loadInventory();
        // prepareData( data );
    }, [] );

    return ( <>
        <Header auth={loginState} />

        <section className="flex justify-start items-start">
            <div className="container mx-auto">
                <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500">Stock</p>
                            <p className="text-2xl font-semibold text-gray-800">Inventory</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                            <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search inventory..." onChange={( e ) => {

                            }} />
                            {loginState.role === UTILS.ADMIN ?
                                <div className="flex flex-col md:flex-row gap-3">
                                    <button className="btn bg-success d-flex align-items-center" onClick={() => navigate( "/inventory/receive", { replace: false, state: storedData } )}><span className="material-icons">south_west</span>&nbsp;Receive</button>
                                    <button className="btn primary-bg d-flex align-items-center" onClick={() => navigate( "/inventory/issue", { replace: false, state: storedData } )}><span className="material-icons">north_east</span>&nbsp;Issue</button>
                                </div> : null}
                        </div>
                    </div>
                </div>

                {loading ? ( <Loading className="mx-auto mt-16" /> ) : ( <>
                    {/* <div className="mt-12">{filteredData.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null} */}
                    <div className="border border-gray-200 rounded-lg p-4 grid md:grid-cols-2 gap-4 md:justify-start md:items-center md:mt-10 flex-wrap" id="list_container">
                        {/* <div className="text-start font-semibold px-2 py-2 bg-gray-50 rounded-md">Total Inventory Items: <span className="bg-green-200 text-green-900 px-3 py-1 rounded-md">{filteredData.length}</span></div>
                        <div className="text-start font-semibold px-2 py-2 bg-gray-50 rounded-md">Total Inventory Value: <span className="bg-green-200 text-green-900 px-3 py-1 rounded-md">{UTILS.thousandSeparator( filteredData.reduce( ( acc, item ) => acc + item.totalAmount, 0 ) )}</span></div> */}
                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                <p className="text-xs uppercase tracking-wide text-gray-500">Inventory Items</p>
                                <p className="text-lg font-semibold text-secondary-500 mt-1">{filteredData.length}</p>
                            </div>
                            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                <p className="text-xs uppercase tracking-wide text-gray-500">Current Inventory Value</p>
                                <p className="text-lg font-semibold text-secondary-500 mt-1">{UTILS.thousandSeparator( filteredData.reduce( ( acc, item ) => acc + item.totalAmount, 0 ) )}</p>
                            </div>
                        </div>
                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                            {loginState.role === UTILS.SALES ? (
                                <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                    <p className="text-xs uppercase tracking-wide text-gray-500">Total Sold</p>
                                    <p className="text-lg font-semibold text-secondary-500 mt-1">{UTILS.thousandSeparator( filteredData.reduce( ( acc, item ) => acc + Number( item.totalSold || 0 ), 0 ) )}</p>
                                </div>
                            ) : ( <>
                                <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                    <p className="text-xs uppercase tracking-wide text-gray-500">Total Issued</p>
                                    <p className="text-lg font-semibold text-secondary-500 mt-1">{UTILS.thousandSeparator( filteredData.reduce( ( acc, item ) => acc + Number( item.totalIssued || 0 ), 0 ) )}</p>
                                </div><div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                    <p className="text-xs uppercase tracking-wide text-gray-500">Total Sold</p>
                                    <p className="text-lg font-semibold text-secondary-500 mt-1">{UTILS.thousandSeparator( filteredData.reduce( ( acc, item ) => acc + Number( item.totalSold || 0 ), 0 ) )}</p>
                                </div></>
                            )}
                        </div>
                    </div>

                    <div className="border border-gray-200 px-3 py-2 mt-4 bg-gray-100 grid col-span-6 md:grid-cols-6 md:justify-start md:items-center md:mt-8 rounded-t-md ">
                        <div className="col-span-1 font-bold">Date</div>
                        <div className="col-span-1 font-bold">Invoice</div>
                        <div className="col-span-1 font-bold">Selling Price</div>
                        <div className="font-bold">Initial Qty</div>
                        <div className="col-span-1 font-bold">Available Qty</div>
                        <div className="text-right font-bold">Total Value</div>
                    </div>
                    <div className="border-x border-b border-gray-200 rounded-b-md grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">

                        {filteredData.length > 0 ? (
                            filteredData.map( ( p, index ) => {
                                return <InventoryItem sn={index} data={p} key={p.product.id} onClick={() => { navigate( "/inventory/view/" + p.id, { replace: false, state: p } ) }} onEdit={() => { navigate( '/inventory/edit/' + p.id, { replace: false, state: p } ) }} />
                            } )
                        ) : <span className="text-center w-full py-8 text-gray-500">No data</span>
                        }
                    </div>
                    {/* </div> */}
                </> )}
            </div>
        </section>
    </> )

}
export default Inventory;
